



















import Vue, { PropType } from 'vue';
import { FileUploadBox } from '@descomplica/vue-components';
import { Document } from '@/store/modules/admission/state';
import i18n from '@/i18n';

export interface SendDocumentFormEvent {
  fileName: string;
  fileDataUrl: string;
}

const FIVE_MB_IN_BYTES = 5 * 1024 ** 2;

export default Vue.extend({
  components: { FileUploadBox },
  props: {
    currentDocument: {
      type: Object as PropType<Document>,
      required: true,
    },
    isDocumentUploadDone: {
      type: Boolean,
      default: false,
    },
    userName: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      fileName: this.currentDocument.name || '',
      fileDataUrl: '' as any,
      maxFileSize: FIVE_MB_IN_BYTES,
      errorMessage: '',
    };
  },
  methods: {
    documentDeleteHandler(event: Event) {
      this.fileName = '';
      this.fileDataUrl = '';
      this.$emit('delete', event);
    },
    documentUploadHandler(file: File) {
      this.fileName = file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.fileDataUrl = reader.result;
        this.emitInputEvent();
      };
    },
    emitInputEvent() {
      const event: SendDocumentFormEvent = {
        fileName: this.fileName,
        fileDataUrl: this.fileDataUrl,
      };

      this.$emit('input', event);

      this.fileDataUrl = '';
    },
    errorHandler(error: 'type' | 'size') {
      this.errorMessage = i18n.t(`fileUploadError.${error}`);
    },
  },
});
